var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6595 0.570312C10.6813 0.570312 0.160156 11.0923 0.160156 24.07C0.160156 37.0477 10.6813 47.5706 23.6595 47.5706C36.6377 47.5706 47.1602 37.0484 47.1602 24.07C47.1602 11.0916 36.6377 0.570312 23.6595 0.570312ZM17.2944 16.2457C17.2944 12.9529 19.9735 10.2743 23.2658 10.2743C26.5582 10.2743 29.2372 12.9532 29.2372 16.2457V23.4183C29.2372 26.7108 26.5582 29.3893 23.2658 29.3893C19.9735 29.3893 17.2944 26.7103 17.2944 23.4183V16.2457ZM32.9637 23.6447C32.9637 28.6051 29.2186 32.7051 24.4076 33.2722V36.5489H26.4133V38.987H19.9644V36.5489H21.97V33.2523C17.2338 32.6169 13.5683 28.5518 13.5683 23.6442V20.2379H16.0063V23.6442C16.0063 27.6469 19.2631 30.9032 23.2658 30.9032C27.2685 30.9032 30.5258 27.6464 30.5258 23.6442V20.2379H32.9639C32.9637 20.2379 32.9637 23.6447 32.9637 23.6447Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.264 26.9511C25.2123 26.9511 26.7974 25.3664 26.7974 23.4181V21.3828H19.7305V23.4181C19.7305 25.3661 21.3156 26.9511 23.264 26.9511Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16);
export default __webpack_public_path__ + "static/media/ico-16.3b025dec17b496e2ef233bec73ef82d6.svg";
export { ForwardRef as ReactComponent };